import { Button, Col, Row, Spin, Tooltip } from 'antd';
import FullCalendar from '@fullcalendar/react';
import timeGridPlugin from '@fullcalendar/timegrid';
import interactionPlugin from '@fullcalendar/interaction';
import moment from 'moment';
import 'moment/locale/fr';
import { useReactToPrint } from 'react-to-print';
import { useAppSelector } from 'app/config/store';
import { isLessThanAnHour } from 'app/shared/util/date-utils';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPrint } from '@fortawesome/free-solid-svg-icons';
import '../classe/classe.scss';
import React, { useEffect, useRef } from 'react';
moment.locale('fr');
const ProfesseurCalendar = () => {
  const componentRef = useRef();
  const calendarRef = useRef<FullCalendar>();
  const professeur = useAppSelector(state => state.professeur.entity);
  const currentAnnee = useAppSelector(state => state.anneeScolaire.entity);
  const loadingCalendar = useAppSelector(state => state.calendarEntry.loading);
  const listCalendarEntry = useAppSelector(state => state.calendarEntry.entities);
  const handlePrint = useReactToPrint({
    content: () => componentRef.current,
    documentTitle: `Emploi du Temps - ${professeur.prenom} ${professeur.nom} ${currentAnnee.nom}`,
  });
  useEffect(() => {
    const resizeObserver = new ResizeObserver(() => {
      if (calendarRef.current) {
        const calendarApi = calendarRef.current.getApi();
        calendarApi.updateSize();
      }
    });
    if (componentRef.current) {
      resizeObserver.observe(componentRef.current);
    }
    return () => {
      if (componentRef.current) {
        resizeObserver.unobserve(componentRef.current);
      }
    };
  }, []);
  const events = listCalendarEntry.map(event => {
    const referenceMonday = moment().startOf('isoWeek');
    const dayMap = {
      LUNDI: 0,
      MARDI: 1,
      MERCREDI: 2,
      JEUDI: 3,
      VENDREDI: 4,
      SAMEDI: 5,
    };
    const dayOffset = dayMap[event.jour];
    const start = referenceMonday.clone().add(dayOffset, 'days').format('YYYY-MM-DD') + `T${event.heureDebut}`;
    const end = referenceMonday.clone().add(dayOffset, 'days').format('YYYY-MM-DD') + `T${event.heureFin}`;
    return {
      id: event.id,
      title: event.matiere?.nom,
      start,
      end,
      backgroundColor: 'transparent',
      borderColor: 'transparent',
      extendedProps: {
        professeurNames: event.professeurs?.map(p => `${p.prenom} ${p.nom}`).join(', ') || '',
        matiere: event.matiere?.nom,
        matiereColor: event.matiere?.color,
        heureDebut: event.heureDebut,
        heureFin: event.heureFin,
        originalJour: event.jour,
      },
    };
  });
  const renderEventContent = eventInfo => {
    const { event } = eventInfo;
    const { professeurNames, matiere, heureDebut, heureFin, matiereColor } = event.extendedProps;
    const formatTime = timeStr => {
      const [hours, minutes] = timeStr.split(':');
      return `${parseInt(hours, 10)}h${minutes}`;
    };
    return (
      <Tooltip title={`${matiere} avec ${professeurNames}`}>
        <div className="event-card" style={{ backgroundColor: matiereColor || '#3788d8' }}>
          <div className="event-header">
            <div className="event-title">{matiere}</div>
          </div>
          <div className="event-time-range">
            {isLessThanAnHour(heureDebut, heureFin) ? (
              ''
            ) : (
              <>
                {formatTime(heureDebut)} - {formatTime(heureFin)}
              </>
            )}
          </div>
        </div>
      </Tooltip>
    );
  };
  return (
    <div className="classe-detail-container">
      <Row justify="end" gutter={[16, 16]} className="calendar-controls" align="middle">
        <Col xs={24} sm={12} md={8} style={{ display: 'flex', justifyContent: 'flex-end' }}>
          <Button type="default" className="action-btn print-btn" onClick={handlePrint}>
            <FontAwesomeIcon icon={faPrint} /> Imprimer
          </Button>
        </Col>
      </Row>
      <div className="calendar-card" ref={componentRef}>
        <h3 className="calendar-title">
          Emploi du Temps - {professeur.prenom} {professeur.nom}
        </h3>
        <Spin spinning={loadingCalendar} tip="Chargement..." className="custom-spin">
          <FullCalendar
            ref={calendarRef}
            plugins={[timeGridPlugin, interactionPlugin]}
            initialView="timeGridWeek"
            events={events}
            eventContent={renderEventContent}
            slotMinTime="07:00:00"
            slotMaxTime="20:00:00"
            slotDuration="00:30:00"
            allDaySlot={false}
            height="auto"
            headerToolbar={{
              left: '',
              center: 'title',
              right: '',
            }}
            initialDate={moment().startOf('isoWeek').format('YYYY-MM-DD')}
            hiddenDays={[0]}
            slotLabelFormat={{ hour: 'numeric', minute: '2-digit', hour12: false }}
            eventTimeFormat={{ hour: 'numeric', minute: '2-digit', hour12: false }}
            weekends={true}
            eventOverlap={false}
            slotEventOverlap={false}
            locale="fr"
            titleFormat={() => `${currentAnnee.nom}`}
            dayHeaderContent={info => (
              <span style={{ color: '#1d3557' }}>{moment(info.date).locale('fr').format('dddd').toUpperCase()}</span>
            )}
          />
        </Spin>
      </div>
    </div>
  );
};
export default ProfesseurCalendar;
